import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import HeroSection from "@/components/story/HeroSection";
import { trackEvent } from "@/lib/analytics";

const Home = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const devMode = searchParams.get("dev") === "true";

  useEffect(() => {
    trackEvent("page_visit", devMode);
  }, []);

  return (
    <main className="min-h-screen bg-background">
      <HeroSection
        onStart={() => {
          trackEvent("start_generation", devMode);
          navigate("/archetypes");
        }}
      />
    </main>
  );
};

export default Home;
